/**
 * Created by lihanying on 2017/7/20.
 */
import React from 'react'
import { Modal, Input, Select } from 'antd'
import { addProfession, modifyProfession } from '../../../api/clubProfession'
const Option = Select.Option

export default class extends React.Component {
  state = {
    totalTypes: [
      {
        id: 0,
        type_name: '台球',
      },
      {
        id: 1,
        type_name: '休闲区',
      },
      {
        id: 2,
        type_name: '棋牌',
      },
      {
        id: 3,
        type_name: '飞镖机',
      },
    ],
  }

  componentDidMount() {
    if (this.props.modalType == 'edit') {
      this.setState({
        type_name: this.props.selectData.name,
        type_id: this.props.selectData.clz,
      })
    }
  }

  handleOk = () => {}

  render() {
    const { visible, totalType } = this.props

    return (
      <div>
        <Modal
          title="添加业务分组"
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width="800px"
        >
          <div style={{ marginTop: '1rem' }}>
            <span className="info-span">分组名称:</span>
            <Input
              defaultValue={
                this.props.selectData ? this.props.selectData.name : ''
              }
              size="large"
              style={{ width: '50%', marginLeft: '1rem' }}
              placeholder="请输入分组名称"
              onChange={(e) => this.props.handleInput(e)}
            />
          </div>
          {/* <div style={{ marginTop: '1rem' }}>
            <span className="info-span">分类:</span>
            <Select
              defaultValue={
                this.props.selectData ? this.props.selectData.clz : ''
              }
              size="large"
              placeholder="请选择一个分类"
              style={{ width: '50%', marginLeft: '2.5rem' }}
              onChange={(value) => this.props.handleSelect(value)}
            >
              {this.state.totalTypes &&
                this.state.totalTypes.map((item, idx) => {
                  return (
                    <Option value={item.id} key={idx}>
                      {item.type_name}
                    </Option>
                  )
                })}
            </Select>
          </div> */}
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubProfession/component/modalAdd.js